import { TextField, Typography } from "@mui/material";

export default function Input(props: any) {
  const {
    disabled,
    label,
    name,
    value,
    onChange,
    onBlur,
    onClick,
    type = "text",
    placeholder,
    error,
    helperText,
    fullWidth = true,
    height,
    width,
    backgroundColor,
    children,
    sx = {},
    ...rest
  } = props;

  const isNativePickerType = ["date", "time", "datetime-local", "month", "week"].includes(type);

  const handleFieldClick = (event: any) => {
    onClick?.(event);
    if (event.defaultPrevented || disabled || !isNativePickerType) return;

    const input = event.currentTarget.querySelector("input") as HTMLInputElement | null;
    if (!input || input.disabled) return;

    try {
      input.showPicker?.();
    } catch {
      input.focus();
    }
  };

  return (
    <div style={{ width: fullWidth ? "100%" : width }}>
      {label && (
        <Typography
          variant="body1"
          fontWeight={700}
          fontSize={14}
          color="#1F2937"
          sx={{ display: "block", textAlign: "left", mb: 0.65, lineHeight: 1.35 }}
        >
          {label}
        </Typography>
      )}
      <TextField
        disabled={disabled}
        name={name}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        onClick={handleFieldClick}
        type={type}
        placeholder={placeholder}
        fullWidth={fullWidth}
        error={error}
        helperText={helperText}
        InputLabel={{ shrink: false }}
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: "var(--case-field-radius, 8px)",
            height: height ?? "var(--case-field-height, 60px)",
            width: width,
            backgroundColor: backgroundColor,
            fontSize: 14,
            transition: "border-color 160ms ease, box-shadow 160ms ease",
            cursor: isNativePickerType && !disabled ? "pointer" : undefined,
          },
          "& .MuiOutlinedInput-root.Mui-disabled": {
            backgroundColor: backgroundColor || "#FAFAFA",
          },
          "& .MuiOutlinedInput-input.Mui-disabled": {
            WebkitTextFillColor: "#5F6676",
          },
          "& input[type=number]::-webkit-inner-spin-button, & input[type=number]::-webkit-outer-spin-button":
          {
            WebkitAppearance: "none",
            margin: 0,
          },
          "& input[type=number]": {
            MozAppearance: "textfield",
          },
          "& input[type=date], & input[type=time], & input[type=datetime-local], & input[type=month], & input[type=week]": {
            cursor: disabled ? "default" : "pointer",
          },
          "& .MuiSelect-select": {
            textAlign: "left",
          },
          ...sx,
        }}
        select={props.select}
        SelectProps={{
          MenuProps: {
            PaperProps: {
              sx: {
                backgroundColor: "#ffffff",
                borderRadius: "12px",
                maxHeight: "300px",
              },
            },
          },
        }}
        {...rest}
      >
        {children}
      </TextField>
    </div>
  );
}
